import type { ProfileWithUser, UserTrial } from "@/types";
import { type ApiRequestOptions, apiJson } from "./apiClient";

export async function getMyProfile(options?: ApiRequestOptions): Promise<ProfileWithUser> {
	return apiJson<ProfileWithUser>("/profile/me", { signal: options?.signal });
}

export async function getMyTrial(options?: ApiRequestOptions): Promise<UserTrial | null> {
	return apiJson<UserTrial | null>("/profile/trial", {
		signal: options?.signal,
	});
}

export async function updateMyProfile(
	input: {
		name?: string | null;
	},
	options?: ApiRequestOptions,
): Promise<ProfileWithUser> {
	return apiJson<ProfileWithUser>("/profile/me", {
		method: "PATCH",
		body: JSON.stringify(input),
		signal: options?.signal,
	});
}
